<template>
  <v-dialog
    v-model="dialog"
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="dark">
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Tareas</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom right offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-toolbar>
      <v-card-text>
        <v-btn color="primary" dark class="ma-2" @click="edit()">
          Editar
        </v-btn>
        <v-list three-line subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{
                !task.nombre ? "Nombre: " : "Nombre: " + task.nombre
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                !task.creado_por
                  ? "Creada por: "
                  : "Creada por: " + nameUsrFn(task.creado_por)
              }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{
                !task.ultimo_editar
                  ? "Última modificación: "
                  : "Última modificación: " + nameUsrFn(task.ultimo_editar)
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{
                !task.prioridad ? "Prioridad: " : "Prioridad: " + prioridadFn()
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                !task.create_at ? "Creada: " : "Creada: " + task.create_at
              }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{
                !task.finish_at ? "Límite: " : "Límite: " + task.finish_at
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Estado:</v-list-item-title>
              <v-list-item-subtitle>
                {{task.estado == 0 ? 'Sin hacer' : 'Completa'}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>Comentarios</v-subheader>
          <span>{{task.comentarios}}</span>
        </v-list>
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({}),
  props: {
    dialog: Boolean,
    task: Object,
  },
  created() {
    this.textPrioridad();
  },
  computed: {
    ...mapState("usuarioNamespace", ["usuarios"]),
  },
  methods: {
    nameUsrFn(id) {
      let me = this;
      let nombre = "";
      let usuarios = this.usuarios;
      usuarios.forEach(e => {
        if (e.id == id) {
          nombre = e.nombre;
        }
      });
      return nombre;
    },
    prioridadFn() {
      let text = ''
      switch (this.task.prioridad) {
        case 1:
          text = 'Baja'
          break;
        case 2:
          text = 'Media'
          break;
        case 3:
          text = 'Alta'
          break;
      }
      return text;
    },
    textPrioridad() {},
    edit(item) {
      this.$emit("edit", this.task);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
